(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvHtmlInput', function () {
            
            return  {
                templateUrl: 'app/fieldinput/html-input.tmpl.html',
                scope: {
                },
                controller: [function () {
                    var drvCtrl = this;

                    activate();

                    function activate() {
                    }
                }],
                controllerAs: 'drvCtrl',
                bindToController: {
                    value: '=',
                    height: '=',
                    field: '=',
                    autoResize: '='
                }
            };
        });
})();